"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetObjectiveCategories = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const categoriesKeys_1 = __importDefault(require("consts/queryKeys/categoriesKeys"));
const useGetObjectiveCategories = (params, options) => {
    const fetchCategories = (signal) => {
        return (0, ObjectivesClient_1.getObjectiveCategory)(params, signal);
    };
    return (0, react_query_1.useQuery)(categoriesKeys_1.default.categories(params), ({ signal }) => fetchCategories(signal), options);
};
exports.useGetObjectiveCategories = useGetObjectiveCategories;
